import { TableCell } from "@tiptap/extension-table";
import { renderIconInCell } from "./firstColumnIcon";
import { applySecondColumnTruncation } from "./truncateSecondColumn";
import { applyIntentColumnModal } from "./intentColumnModal";
import type { MentionUser, MentionDocument } from "./MentionSuggestion";

export interface ReadOnlyFirstColumnCellOptions {
  mentionUsers?: MentionUser[];
  mentionDocuments?: MentionDocument[];
}

export const ReadOnlyFirstColumnCell = TableCell.extend<ReadOnlyFirstColumnCellOptions>({
  addOptions() {
    return {
      ...this.parent?.(),
      mentionUsers: [],
      mentionDocuments: []
    };
  },

  addNodeView() {
    return ({ node, getPos, editor, HTMLAttributes }) => {
      const dom = document.createElement("td");
      Object.entries(HTMLAttributes).forEach(([key, value]) => {
        dom.setAttribute(key, value as string);
      });

      const pos = typeof getPos === "function" ? getPos() : null;
      const columnIndex =
        pos !== null && pos !== undefined
          ? editor.state.doc
              .resolve(pos)
              .index(editor.state.doc.resolve(pos).depth)
          : -1;

      if (columnIndex === 0) {
        dom.contentEditable = "false";

        if (renderIconInCell(dom, node.textContent)) {
          return { dom };
        }
      }

      const contentDOM = document.createElement("div");

      if (columnIndex === 1) {
        return applySecondColumnTruncation(dom, contentDOM);
      }

      // Intent column: truncate + click to open editable modal
      const intentSpec = applyIntentColumnModal(
        dom,
        contentDOM,
        editor,
        pos,
        columnIndex,
        {
          editable: true,
          getPos: typeof getPos === "function" ? getPos : undefined,
          mentionUsers: this.options.mentionUsers,
          mentionDocuments: this.options.mentionDocuments
        }
      );
      if (intentSpec) {
        return intentSpec;
      }

      dom.appendChild(contentDOM);
      return { dom, contentDOM };
    };
  }
});
